import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    date_range: [],
    page: 1,
    page_size: 28,
    categories: [],
    category_data: [],
    PieChartSett: {
      width: 'auto',
      height: 600,
      is3D: false,
      pieSliceText: 'value',
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      }
    }
  },

  mutations: {
    setDateRange(state, payload) {
      state.date_range = [payload.start, payload.end]
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setCategoryTable(state, payload) {
      state.categories = payload
    },
    setCategory(state, payload) {
      state.category_data = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readCategoriesChartData({ commit, state }) {
      commit('setLoading', true)
      axios.api
        .get('report/data/category', {
          params: {
            start: state.date_range[0],
            end: state.date_range[1],
            merge: true,
            charts: true
          }
        })
        .then(r => {
          commit('setCategory', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readCategoriesData({ commit, state }) {
      commit('setLoading', true)
      axios.api
        .get('report/data/category', {
          params: {
            page: state.page,
            page_size: state.page_size,
            start: state.date_range[0],
            end: state.date_range[1],
            merge: false,
            charts: false
          }
        })
        .then(r => {
          let data = r.data.data.data.filter(
              (d, i, s) => i === s.findIndex(t => t.category_id === d.category_id)
          )
          commit('setCategoryTable', data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  },

  getters: {
    category_chart: state => {
      let result = []
      for (let i = 0; i < state.category_data.length; i++) {
        if (i === 0) {
          state.category_data.map(s => {
            result.push([s[1], s[2]])
          })
        }
      }
      return result
    }
  }
}
